export default {
      id: "icon-campaigns-usage",
      viewBox: "0 0 16 16",
      url: "/" + "assets/sprite.svg#icon-campaigns",
      toString: function () {
        return this.url;
      }
    }